import React from 'react';

class WeeklyGoalSlider extends React.Component {

    sliderConst = {
        min: 0, 
        max: 90, 
        step: 15
    };
    mouseMoving = false;

    constructor(props) {
        super(props);
        this.sliderRef = React.createRef();
        this.sliderBg = React.createRef();
    }

    componentDidMount() {
      if(this.props.behaviourQuestEnabled) {
        this.sliderConst = {
          min: 0,
          max: 35,
          step: 5
        };
      }
      this.mouseMoving = false;
      this.attachSlider();
    }

    attachSlider() {
        let widthPercent = this.sliderConst.step * 100/(this.sliderConst.max - this.sliderConst.min) + '%';
        let sliderControl = this.sliderRef.current ? this.sliderRef.current : null;
        let index = this.sliderConst.min + this.sliderConst.step;

        while(index <= this.sliderConst.max) {
            let li = document.createElement('li');
            li.style.width = widthPercent;
            let span = document.createElement('span');
            span.innerHTML = index+ ' min';
            li.appendChild(span);
            sliderControl.appendChild(li);
            index += this.sliderConst.step;
        }
        const steps = this.props.progress/this.sliderConst.step;
        this.setSliderWidth(steps);
    }

    changeSlider = (event) => {

        const totalWidth = this.sliderRef.current.getBoundingClientRect().width;
        const currentWidth = event.clientX - this.sliderRef.current.getBoundingClientRect().left;

        const widthPer = (currentWidth/totalWidth)*100;

        const stepWidth = (this.sliderConst.step * 100)/(this.sliderConst.max - this.sliderConst.min);

        let totalStep = Math.round(widthPer/stepWidth);

        // Fixing the minimum step to be as 1 or (minimum 15 mins)
        if (totalStep < 1) {
            totalStep = 1;
        } else if(totalStep > (this.sliderConst.max/this.sliderConst.step)) {
            totalStep = this.sliderConst.max/this.sliderConst.step;
        }
        this.setSliderWidth(totalStep, true);
    }

    // Method to set the slider
    setSliderWidth(totalStep, fromEvent = false) {
        const stepWidth = (this.sliderConst.step * 100)/(this.sliderConst.max - this.sliderConst.min);
        const newwidth = totalStep*stepWidth;
        this.sliderBg.current.style.width = (newwidth > 100 ? 100: newwidth)+ '%';

        if(this.props.behaviourQuestEnabled && fromEvent) {
          trackAnalyticsEvent('Interacted Weekly Goal Page', {
            'Clicked On': 'Time Goal'
          });
        }
        this.props.onChange(totalStep*this.sliderConst.step);
    }

    componentDidUpdate() {
        const steps = this.props.progress/this.sliderConst.step;
        this.setSliderWidth(steps);
    }

    mouseDown = (event) => {
        // Some browsers causes issues with images/links like in firefox
        event.preventDefault();
        this.mouseMoving = true;
    }

    mouseUp = () => {
        this.mouseMoving = false;
    }

    mouseMove = (event) => {
        if(this.mouseMoving) {
            if(event.touches) {
                this.changeSlider(event.touches[0]);
            } else {
                this.changeSlider(event);
            }
        }
    }

    render() {
        return (
            <div className="goal-container" onMouseLeave={this.mouseUp}>
                <div className="goal-mark" onMouseDown={(e) => {this.mouseDown(e)}}  onMouseUp={this.mouseUp} onMouseMove={(e) => this.mouseMove(e)} 
                onTouchStart={this.mouseDown} onTouchEnd={this.mouseUp} onTouchMove={(e) => this.mouseMove(e)} >
                    <div className="right-padding">
                        <div className="slider-bg" ref={this.sliderBg} onClick={ (e) => this.changeSlider(e)}>
                            <a className="slider-handle"/>
                        </div>
                    </div>
                    <ul className="slider" ref={this.sliderRef} onClick={ (e) => this.changeSlider(e)}></ul>
                </div>
                <ul className="level-label">
                    <li>Easy Going</li>
                    <li>Recommended</li>
                    <li>Intense</li>
                </ul>
            </div>
        );
    }
}

export default WeeklyGoalSlider;